<template>
	<el-dialog
		class="el-dialogs"
		:close-on-click-modal="false"
    :show-close="false"
		:visible.sync="dialogVisible"
		width="300"
		append-to-body
		title="转入源思康会员卡"
		center
	>
		<el-form
			ref="form"
			label-position="right"
			:model="form"
			label-width="100px"
		>
			<el-form-item label="电话号码：" class="flex-row">
				{{userInfo.mobile}}
			</el-form-item>
			<el-form-item label="卡名称：" class="flex-row">
				{{cardList.storeValueName}}
			</el-form-item>
			<el-form-item label="卡内余额：" class="flex-row">
				{{cardList.surplusMoney}}元
			</el-form-item>
			<el-form-item label="转入余额：" class="flex-row">
				{{userInfo.payPrice}}元
			</el-form-item>
			<!-- <el-form-item
				label="转入余额："
				prop="amount"
				class="flex-row">
				<div class="flex-row">
					<el-input
						placeholder="请输入转入余额"
						:maxlength="8"
						v-model="form.amount">
					</el-input>
				</div>
			</el-form-item> -->
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="cancel">取 消</el-button>
			<el-button type="primary" @click="save">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import Dialog from '../../components/common/dialog.vue'
import { decrypt, encrypt } from '../../assets/javascript/untils'
export default {
	data() {
		return {
			dialogVisible: false,
			appInfo: this.$store.getters.AppInfo,
			userInfo: {},
      		cardList: {},
			form: {
        		amount: "",
				millisecond: "",
			},
		}
	},
	mounted() {
		this.$on('open', function(org) {
			this.userInfo = org.form;
      		this.cardList = org.cardList;
			this.dialogVisible = true;
			this.form.amount = org.form.payPrice;
		})
	},
	components: { Dialog },
	computed: {},
	created() {
		// this.getvCode();
	},
	methods: {
		save() {
			if (!this.form.amount) {
				this.$message.error('请输入转入金额');
				return false
			} else if (this.form.amount == 0) {
        return this.$message.error("金额不能为0");
      } else if (!/^(([1-9]{1}\d*)|(0))(\.\d{1,2})?$/.test(this.form.amount)) {
        this.$message.error('请输入正确的金额数字，最多两位小数');
				return false
      } else if (Number(this.form.amount) > this.cardList.surplusMoney) {
        return this.$message.error("转入金额不能大于卡内金额");
      }
      this.$confirm("确定将余额转入vip卡", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        type: "warning"
      }).then(() => {
        this.form.memberId = this.userInfo.id;
        this.form.storeValueCode = this.cardList.storeValueCode;
        this.form.millisecond = new Date().getTime();
        let arr = encrypt(JSON.stringify(this.form))
        this.$api.post(this.$url.storeYuanjianBill.doTransfer, arr).then((res) => {
          if (res) {
            this.$api.success('转入成功')
            this.dialogVisible = false;
            this.form.amount = '';
            this.$emit("change", true)
          }
        }).catch((error) => {})
      }).catch(() => {}); 
		},
    cancel () {
      this.form.amount = '';
      this.dialogVisible = false;
    }
	},
}
</script>

<style scoped lang="less">
.el-form-item-update {
	display: flex;
	align-items: center;
	justify-content: space-between;
	/deep/ .el-form-item__label {
		font-size: 16px;
		font-weight: 500;
		// text-align: left;
	}
	/deep/ .el-form-item__content {
		// flex: 2;
		width: 200px;
		text-align: left;
	}
}
.password {
	cursor: pointer;
}
.btn {
	line-height: 30px;
}
/deep/ .el-dialog {
	width: 460px;
	overflow: auto;
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
div .el-dialog__footer {
	border: 0;
}
/deep/ .el-dialog__body {
	padding: 10px 20px;
}
</style>
